import React, { useState } from 'react';
import { login } from '../auth/authService';
import logo from '../logo.svg';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    const success = await login(username, password);
    if (!success) {
      setError('Verkeerde gebruikersnaam of wagwoord. Probeer weer.');
    } else {
      setError('');
    }
  };

  return (
    <div className="login-page">
      <div className="login-brand">
        <img src={logo} alt="Melktert" />
      </div>

      <div className="card login-card">
        <h2 className="login-title">Meld aan</h2>

        <form onSubmit={handleLogin}>
          <div className="field">
            <label htmlFor="username" className="label">Gebruikersnaam</label>
            <input
              type="text"
              id="username"
              className="input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Vul jou gebruikersnaam in"
              required
              autoCapitalize="none"
              autoCorrect="off"
              autoComplete="username"
              spellCheck={false}
            />
          </div>

          <div className="field">
            <label htmlFor="password" className="label">Wagwoord</label>
            <input
              type="password"
              id="password"
              className="input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Vul jou wagwoord in"
              required
            />
          </div>

          <button type="submit" className="btn btn-primary btn-block">
            Meld aan
          </button>
        </form>

        {error && <p className="login-error">{error}</p>}
      </div>
    </div>
  );
};

export default Login;
